export const SORT_ORDERS = <const>{
  ascend: 'ascend',
  descend: 'descend',
};

export type SortOrder = keyof typeof SORT_ORDERS;

export const determineIsSortOrder = (value: string | null): value is SortOrder =>
  !!value && Object.keys(SORT_ORDERS).includes(value);
